<div class="img" (click)="PostRequestVideo(id)">
    <span>{{time}}</span>
    <img [src]="url" alt="">
</div>